export default __webpack_public_path__ + "static/media/Mark-Heavy.v1.e63a56e0.woff2";